import * as React from "react";

const Print = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer21"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeWidth="0.4"
    >
      <path
        id="rect98"
        fill="none"
        stroke="#000"
        d="M5.82 2.117v2.116a.53.53 135 0 1-.528.53H1.058a.53.53 45 0 1-.529-.53V2.117a.53.53 135 0 1 .53-.53h4.233a.53.53 45 0 1 .529.53z"
        opacity="1"
      ></path>
      <path
        id="rect99"
        fill="none"
        stroke="#000"
        d="M4.762.794v.793H1.588V.794a.265.265 135 0 1 .264-.265h2.646a.265.265 45 0 1 .264.265z"
        opacity="1"
      ></path>
      <rect
        id="rect102"
        width="3.175"
        height="1.72"
        x="1.587"
        y="4.101"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        opacity="1"
        rx="2.348"
        ry="0"
      ></rect>
      <path
        id="path100"
        fill="none"
        stroke="#000"
        d="M4.762 1.034v1.601a.143.143 135 0 1-.142.143H1.73a.143.143 45 0 1-.143-.143V1.034A.37.37 135 0 1 1.96.66h2.43a.37.37 45 0 1 .372.373Z"
        opacity="1"
        transform="rotate(180 3.175 3.241)"
      ></path>
      <path
        id="path102"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        d="M2.381 4.375h.794"
        opacity="1"
      ></path>
      <path
        id="path103"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        d="M2.381 5.15H3.97"
        opacity="1"
      ></path>
      <circle
        id="path104"
        cx="1.587"
        cy="2.555"
        r="0.26"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        opacity="1"
      ></circle>
    </g>
  </svg>
);

export default Print;
